import { NgModule } from "@angular/core";
import { CurrencyInfoPipe } from "./currency-info.pipe";
import { CustomDatePipe } from "./custom-date.pipe";
import { NotificationDatePipe } from './notification-date.pipe';

@NgModule({
  declarations: [	
    CustomDatePipe,
    NotificationDatePipe,
    CurrencyInfoPipe
  ],
  exports: [
    CustomDatePipe,
    NotificationDatePipe,
    CurrencyInfoPipe
  ]
})
export class CustomPipeModule { }